import { render, staticRenderFns } from "./apiscope.vue?vue&type=template&id=0fa6b910&"
import script from "./apiscope.vue?vue&type=script&lang=js&"
export * from "./apiscope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports